import styled from '@emotion/styled';

import { BubbleSVG } from '../../components/BubbleSVG';
import { media } from '../../services/media';

export const Bubble = styled(BubbleSVG)`
    width: 530px;

    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: -200px;
    margin-bottom: 28px;

    text-align: center;
    color: white;

    ${media.min('md')} {
        position: absolute;
        top: -50px;
        right: calc(100% - 358px);
        left: auto;
        transform: none;
        margin-top: 0;
        margin-bottom: 0;
    }

    ${media.min('lg')} {
        right: calc(100% - 400px);
    }

    ${media.min('xl')} {
        width: 640px;

        right: calc(100% - 475px);
    }

    ${media.min('xxl')} {
        width: 680px;

        right: calc(100% - 33vw);
    }
`;
